import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { useTrackVisibility } from "react-intersection-observer-hook";

export function CookiePolicyContents() {
	const [ref] = useTrackVisibility();

	const _renderWhatAreCookies = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">What Are Cookies?</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Cookies are simple text files that are stored on your computer or mobile device by a websites
					server. Each cookie is unique to your web browser. It will contain some anonymous information such
					as a unique identifier, website’s domain name, and some digits and numbers.
				</RATypography>
			</>
		);
	};

	const _renderTypeOfCookies = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">What Types Of Cookies Do We Use?</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					Cookies are simple text files that are stored on your computer or mobile device by a websites
					server. Each cookie is unique to your web browser. It will contain some anonymous information such
					as a unique identifier, website’s domain name, and some digits and numbers.
				</RATypography>
				<RATypography variant="sub-heading3" color="#222222" top={20}>
					Necessary Cookies
				</RATypography>
				<RATypography variant="body3" color="#595959" top={10}>
					Cookies are simple text files that are stored on your computer or mobile device by a websites
					server. Each cookie is unique to your web browser. It will contain some anonymous information such
					as a unique identifier, website’s domain name, and some digits and numbers.
				</RATypography>
				<RATypography variant="sub-heading3" color="#222222" top={20}>
					Functionality Cookies
				</RATypography>
				<RATypography variant="body3" color="#595959" top={10}>
					Functionality cookies let us operate the site in accordance with the choices you make. For example,
					we will recognize your username and remember how you customized the site during future visits.
				</RATypography>
				<RATypography variant="sub-heading3" color="#222222" top={20}>
					Analytical Cookies
				</RATypography>
				<RATypography variant="body3" color="#595959" top={10}>
					These cookies enable us and third-party services to collect aggregated data for statistical purposes
					on how our visitors use the website. These cookies do not contain personal information such as names
					and email addresses and are used to help us improve your user experience of the website.
				</RATypography>
			</>
		);
	};

	const _renderHowToDeleteCookies = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">How To Delete Cookies?</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					If you want to restrict or block the cookies that are set by our website, you can do so through your
					browser setting. Alternatively, you can visit{" "}
					<b style={{ color: "#222222" }}>www.internetcookies.org</b>, which contains comprehensive
					information on how to do this on a wide variety of browsers and devices. You will find general
					information about cookies and details on how to delete cookies from your device.
				</RATypography>
			</>
		);
	};

	const _renderContactUs = () => {
		return (
			<>
				<Content>
					<RATypography variant="h3">Contacting Us</RATypography>
				</Content>
				<RATypography variant="body3" color="#595959" top={20}>
					If you have any questions about this policy or our use of cookies, please contact us at{" "}
					<b style={{ color: "#222222" }}>
						<u>info@royalair.com</u>
					</b>
					.
				</RATypography>
			</>
		);
	};

	return (
		<HomeContactContainer ref={ref}>
			<RATypography variant="body3" color="#595959" top={20}>
				Please read this cookie policy carefully before using https://royalair.com websites or services operated
				by Royal Air Charter.
			</RATypography>
			<WrapperContent>{_renderWhatAreCookies()}</WrapperContent>
			<WrapperContent>{_renderTypeOfCookies()}</WrapperContent>
			<WrapperContent>{_renderHowToDeleteCookies()}</WrapperContent>
			<WrapperContent>{_renderContactUs()}</WrapperContent>
		</HomeContactContainer>
	);
}

const HomeContactContainer = styled.div`
	width: 100%;
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 40px;
	border-radius: 12px;
`;
const WrapperContent = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
`;
const Content = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
